import { obDefaultValGet } from "common/common";
import { sortFieldsGet } from "common/search/search_common";
import { SEARCH_NAMES } from "constant/search";

export const panelSearchFieldsGet = (searchFieldOb: any = null): any => {
  let result = null;
  if (searchFieldOb === null) {
    result = {
      [SEARCH_NAMES.DATUM]: "",
      [SEARCH_NAMES.DATUM_RANGE_TYPE]: "",
      [SEARCH_NAMES.DATUM_SECOND_RANGE]: "",
    };
  } else {
    result = {
      [SEARCH_NAMES.DATUM]: obDefaultValGet(
        searchFieldOb,
        SEARCH_NAMES.DATUM,
        ""
      ),
      [SEARCH_NAMES.DATUM_RANGE_TYPE]: obDefaultValGet(
        searchFieldOb,
        SEARCH_NAMES.DATUM_RANGE_TYPE,
        ""
      ),
      [SEARCH_NAMES.DATUM_SECOND_RANGE]: obDefaultValGet(
        searchFieldOb,
        SEARCH_NAMES.DATUM_SECOND_RANGE,
        ""
      ),
    };
  }

  const sortFields = sortFieldsGet(searchFieldOb);
  result = { ...result, ...sortFields };

  return result;
};
